import { jsx } from "panel";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { InputEl } from "common/components/input";
import { CopyToClipboardButtonEl } from "./copy-to-clipboard-button";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-copy-to-clipboard"
  }, /* @__PURE__ */ jsx(InputEl, {
    sel: ".copy-input",
    attrs: {
      readonly: true,
      type: `text`,
      label: this.attr(`label`)
    },
    props: {
      value: this.attr(`value`)
    },
    hook: {
      insert: ({ elm }) => this.helpers.handleInsert(elm)
    }
  }), /* @__PURE__ */ jsx(CopyToClipboardButtonEl, {
    sel: ".copy-button",
    attrs: { value: this.attr(`value`), size: ButtonSize.Large, theme: ButtonTheme.Tertiary }
  }, "Copy"));
}
